const TOKEN_FIELD_SELECTOR = 'input[data-recaptcha-sitekey]';

const pendingForms = new WeakSet();
const verifiedForms = new WeakSet();

function requestToken(siteKey, action) {
    return new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
            try {
                window.grecaptcha.execute(siteKey, { action }).then(resolve, reject);
            } catch (error) {
                reject(error);
            }
        });
    });
}

function resubmit(form, submitter) {
    verifiedForms.add(form);

    if (submitter) {
        form.requestSubmit(submitter);
    } else {
        form.requestSubmit();
    }
}

function findTokenField(form) {
    if (!(form instanceof HTMLFormElement) || typeof form.requestSubmit !== 'function' || !window.grecaptcha) {
        return null;
    }

    return form.querySelector(TOKEN_FIELD_SELECTOR);
}

function handleSubmit(event) {
    const form = event.target;
    const tokenField = findTokenField(form);
    if (!tokenField) {
        return;
    }

    if (verifiedForms.has(form)) {
        verifiedForms.delete(form);
        return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (pendingForms.has(form)) {
        return;
    }

    const { submitter } = event;
    const { recaptchaSitekey, recaptchaAction } = tokenField.dataset;

    pendingForms.add(form);
    tokenField.value = '';

    requestToken(recaptchaSitekey, recaptchaAction)
        .catch((error) => {
            console.error(error);
            return '';
        })
        .then((token) => {
            tokenField.value = token;
            pendingForms.delete(form);
            resubmit(form, submitter);
        });
}

document.addEventListener('submit', handleSubmit, true);



// WEBPACK FOOTER //
// ./js/modules/googleRecaptcha.js